import { brand } from '../../config/brand'

type Props = {
  mark?: boolean
  nameClassName?: string
  /** White-bg logo fails on dark chrome — text only. */
  onDark?: boolean
}

/** Full logo on light chrome; text wordmark on dark or when no asset. */
export function BrandWordmark({ mark = true, nameClassName, onDark = false }: Props) {
  if (!onDark && brand.logo) {
    return <img src={brand.logo} alt={brand.name} className="brand-logo" />
  }
  return (
    <>
      {mark ? <div className="brand-mark" aria-hidden="true">S</div> : null}
      <div className={nameClassName || 'brand-tt'}>{brand.name}</div>
    </>
  )
}
